<template>
<div class="chapter">
<div class="inner_page">
<p class="end-title-A"><span><b>PRAISE FOR THE WRITING OF NORMA FOX MAZER</b></span></p>
<p class="normal">“Mazer is one of the best of the practitioners writing for young people today.” —<i>The New York Times</i></p>
<p class="normal-1">“It’s not hard to see why Norma Fox Mazer has found a place among the most popular writers for young adults these days.” —<i>The Washington Post Book World</i></p>
<p class="end-title1-A"><span><i>A, My Name Is Ami</i></span></p>
<p class="normal-1">“A satisfying novel about the ups and downs of 12-year-old Ami’s relationship with her best friend Mia … The writing is light but consistently sensitive and realistic, as the joys and disasters of the characters flow towards a moving and memorable ending.” —<i>School Library Journal</i></p>
<p class="normal-1">“The atmosphere and the girls are right on target.… An accurate slice of teenage life.” —<i>Publishers Weekly</i></p>
<p class="end-title1-A"><span><i>B, My Name Is Bunny</i></span></p>
<p class="normal-1">“[Bunny] is a likeable, true-to-life character who hates her name and wants to be a professional clown. Her friendship with Emily is the source and depth of this simple story of two teenagers learning about life … [a] story of growth and acceptance with accurate and touching emotions.” —<i>School Library Journal</i></p>
<p class="end-title1-A"><span><i>C, My Name Is Cal</i></span></p>
<p class="normal-1">“Deftly sketched … Mazer’s skill in telling the reader more about Cal than he knows about himself, while narrating Cal’s unique, taciturn voice, is especially memorable.” —<i>Kirkus Reviews</i></p>
<p class="normal-1">“Readers will recognize themselves.” —<i>Booklist</i></p>
<p class="end-title1-A"><span><i>Dear Bill, Remember Me?</i></span></p>
<p class="end-title1-A1"><span>A New York Times Notable Book and a Kirkus Choice</span></p>
<p class="normal-1">“Highly accomplished short stories, variously funny and moving, about ordinary, contemporary girls and their relationships with mothers or boyfriends.” —<i>Kirkus Reviews</i></p>
<p class="normal-1">“Eight short stories, powerful and poignant, about young women at critical points in their lives.” —<i>The New York Times</i></p>
<p class="normal-1">“Stories that are varied in mood and style and alike in their excellence.” —<i>The Bulletin of the Center for Children’s Books</i></p>
<p class="end-title1-A"><span><i>Summer Girls, Love Boys</i></span></p>
<p class="normal-1">“Featuring female protagonists, the stories mix the bitter and the sweet of life while encompassing a variety of narrative techniques, settings, themes, and tones.… Mazer writes honestly and provocatively of human emotion and circumstances while she demonstrates her versatility as a writer.” —<i>Booklist</i></p>
<p class="end-title1-A"><span><i>Good Night, Maman</i></span></p>
<p class="normal-1">“Mazer writers with a simplicity that personalizes the history.… Direct … honest.” —<i>Booklist, starred review</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?3974f194